'use strict';
(function(angular) {
  angular.module('activationApp.services')
    .factory('locationService', [
      '$state',
      '$location',
      '$rootScope',
      'dataService',
      function(
        $state,
        $location,
        $rootScope,
        dataService) {
        return {
          goBack: function() {
            if ($rootScope.user.success) {
              return false;
            }

            switch ($location.path()) {
            case '/activate/step1':
              if (dataService.showPartners()) {
                $state.transitionTo('options');
              } else {
                $state.transitionTo('welcome');
              }
              break;
            case '/activate/step2':
              $state.transitionTo('activate.step1');
              break;
            case '/activate/step3':
              $state.transitionTo('activate.step2');
              break;
            case '/activate/step4':
              $state.transitionTo('activate.step3');
              break;
            }
          },

          goNext: function() {
            switch ($location.path()) {
            case '/activate/step1':
              $state.transitionTo('activate.step2');
              break;
            case '/activate/step2':
              $state.transitionTo('activate.step3');
              break;
            case '/activate/step3':
              $state.transitionTo('activate.step4');
              break;
            case '/activate/step4':
              $state.transitionTo('activate.step5');
              break;
            }
          },

          goingForward: function(fromState, toState) {
            if (fromState.name === 'activate.step1' &&
            (toState.name === 'activate.step2' ||
              toState.name === 'activate.step3' ||
              toState.name === 'activate.step4' ||
              toState.name === 'activate.step5')) {
              return true;
            } else if (fromState.name === 'activate.step2' &&
            (toState.name === 'activate.step3' ||
              toState.name === 'activate.step4' ||
              toState.name === 'activate.step5')) {
              return true;
            } else if (fromState.name === 'activate.step3' &&
            (toState.name === 'activate.step4' ||
              toState.name === 'activate.step5')) {
              return true;
            } else if (fromState.name === 'activate.step4' &&
            (toState.name === 'activate.step5')) {
              return true;
            }

            return false;
          },

        };
      }]);
})(angular);

